<h3 class="pl-1 pr-1">Clone: {{ editDetails?.formTitle }}</h3>
<app-team-edit-details #editDetails [teamId]="teamId" [cloneMode]="true">
</app-team-edit-details>
<mat-dialog-actions>
  <button
    mat-flat-button
    color="primary"
    [disabled]="!editDetails.valid || saving"
    (click)="cloneTeam()"
  >
    Create
  </button>
  <button type="button" mat-stroked-button (click)="dialogRef.close()">
    Cancel
  </button>
</mat-dialog-actions>
